
import {EntryPoint} from '../uikit';

// We still need to use ES5 require because of the
// way the Cart script is currently written
import CartAPI from '../services/CartAPI';
import Cart from '../components/Cart/Cart';

export class CartEntryPoint extends EntryPoint {

  initialize() {
    CartAPI.init();
    Cart.getInitialCartInfo();  // Fetch the initial cart details
  }

}




// WEBPACK FOOTER //
// ./assets/entryPoints/CartEntryPoint.js